// ### AdobeClientlessAuth
//
// Using our mock AccessEnabler to Adobe's REST API.

'use strict';

var AdobeBaseAuth = require('./adobebaseauth');
var ClientlessAccessEnabler = require('./clientlessaccessenabler');
var App = require('./app');
var ENV = require('./env');
var _ = require('./vendor/underscore');
var _logger = require('./logger');


var AdobeClientlessAuth = AdobeBaseAuth.extend({
	type: 'clientless',
	PRODUCTION_ACCESS_ENABLER_URL: 'https://' + App.ADOBE_API_PRODUCTION_HOST,
	STAGING_ACCESS_ENABLER_URL: 'https://' + App.ADOBE_API_STAGING_HOST,
	PLATFORM_PROPERTY: 'clientless',

	checkRegistrationCode: function (regcode) {
		_logger.log('AdobeClientlessAuth:checkRegistrationCode');

		this.accessEnabler.checkRegcode(regcode);
	},

	getSelectedProvider: function (callback, context) {
		_logger.log('AdobeClientlessAuth:getSelectedProvider');

		if (!_.isFunction(callback)) {
			_logger.error('getSelectedProvider requires an async callback');
			throw new Error('AdobeClientlessAuth::getSelectedProvider requires an async callback');
		}

		this.once('selectedProvider', callback, context);

		// make sync request
		_logger.info('Adobe:call - getSelectedProvider');
		var result = this.accessEnabler.getSelectedProvider();

		result = this._validateSelectedProvider(result);

		// immediately resolve as the Clientless AccessEnabler is synchronous (cuz we faked it)
		this.emit('selectedProvider', result);
	},

	setProviderDialogURL: function (/*url*/) {
		_logger.log('AdobeClientlessAuth:setProviderDialogURL');
		// no Adobe method defined for Clientless
	},

	externalizeCallbacks: function () {
		_logger.log('AdobeClientlessAuth:externalizeCallbacks');

		// this takes all the internal methods for adobe callbacks and
		// exposes them to the global scope so adobe can access them
		this._super();

		window.entitlementLoaded = _.bind(this._adobeCallback_entitlementLoaded, this);
		window.registrationCodeValid = _.bind(this._adobeCallback_registrationCodeValid, this);
		window.registrationCodeInvalid = _.bind(this._adobeCallback_registrationCodeInvalid, this);
	},

	_adobeCallback_entitlementLoaded: function () {
		_logger.info('Adobe:callback - entitlementLoaded');

		this.setRequestor(this.getRequestorId());
	},

	_adobeCallback_registrationCodeValid: function (regCode) {
		_logger.info('Adobe:callback - registrationCodeValid');

		this.emit('registrationCodeValid', {
			regCode: regCode
		});
	},

	_adobeCallback_registrationCodeInvalid: function (regCode) {
		_logger.info('Adobe:callback - registrationCodeInvalid');

		this.emit('registrationCodeInvalid', {
			regCode: regCode
		});
	},

	init: function (options) {
		_logger.log('AdobeClientlessAuth:init', arguments);

		this._super(options);

		if (!_.isString(options.platform)) {
			throw new Error('"platform" config must be provided for Clientless Auth!');
		}

		this.PLATFORM_PROPERTY = options.platform;

		// set a pointer to our mock AccessEnabler
		this.accessEnabler = ClientlessAccessEnabler;

		this.configuredEnv = options.vendorEnv;

		this.accessEnablerUrl = (
			this.getUrlForEnv(ENV.getVendorOverrideParam())
			|| this.getUrlForEnv(this.configuredEnv)
			|| this.PRODUCTION_ACCESS_ENABLER_URL
		);
	},

	install: function () {
		_logger.log('AdobeClientlessAuth:install');

		this._super();

		this.accessEnabler.init({
			apiOrigin: this.accessEnablerUrl,
			deviceType: this.options.platform,
			domain: this.options.domain
		});
	}

});


module.exports = AdobeClientlessAuth;
